<template>
  <div class="product-list-container">
    <div class="list-container__wrapper" :class="[$route.name]">
      <div class="product-nav-container" :class="[menuSwitch ? 'hidden' : '']">
        <div class="nav__container">
          <router-link
            :to="{
              path: `/products/img/${item.name.en}/${item.id}`
            }"
            class="nav__item"
            :class="{
              '-current-type': Number(activeNav) === index
            }"
            v-for="(item, index) in navs"
            :key="index"
            @mouseenter.native="onMouseEnter"
            @mouseleave.native="onMouseLeave"
            :data-queue="index"
          >
            <template v-if="$bowser.mobile">
              <p>
                {{ item.name.en }}
                <span v-if="Number(activeNav) === index">| {{ item.name.cn }}</span>
              </p>
            </template>
            <template v-else>
              <p
                :class="{
                  hoverShow: !$bowser.mobile
                }"
              >
                <span>{{ item.name.en }}</span>
                <span>{{ item.name.cn }}</span>
              </p>
            </template>
            <div
              class="moveLine"
              :style="{
                backgroundColor: lineColor
              }"
            ></div>
            <p class="count">{{ item.counts | fillzero }}</p>
          </router-link>
        </div>
        <div class="nav__container">
          <router-link
            href="javascript:void(0)"
            class="nav__item"
            v-for="(type, index) in listTypeNavs"
            :key="index"
            :to="{
              path: type.link
            }"
            active-class="actived"
            :class="{
              actived:
                $route.params.type === undefined && $route.params.name === undefined && index === 0
            }"
          >
            <p>{{ type.name }}</p>
            <div
              class="moveLine"
              :style="{
                backgroundColor: lineColor
              }"
            ></div>
          </router-link>
        </div>
      </div>
      <router-view v-if="projects.length > 0" :lists="projects"></router-view>
      <p style="text-align:center;padding-top:300px;" v-else>暂无数据</p>
    </div>
    <page-footer class="product-list" ref="pageFooter"></page-footer>
    <mobile-top-nav v-if="$bowser.mobile" :type-navs="listTypeNavs" :navs="navs"></mobile-top-nav>
    <up-bt v-else @backTop="onBackTop"></up-bt>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { products } from '@/utils/data';
import pageFooter from '../common/footer.vue';
import upBt from '../common/up-bt.vue';
import mobileTopNav from './_mobile-top-nav.vue';

const colors = ['#00a69b', '#c3d714', '#f8b61c', '#ae027e'];
export default {
  name: 'page-product-list',
  components: {
    pageFooter,
    upBt,
    mobileTopNav,
  },
  data() {
    return {
      navs: [],
      listTypeNavs: [],
      projects: [],
      hoverNav: null,
      activeNav: 0,
    };
  },
  computed: {
    ...mapState({
      menuSwitch: 'd1MenuSwitch',
    }),
    lineColor() {
      const temp = colors;
      const data = [];
      for (let i = 0; i < 2; i += 1) {
        const c = Math.floor(Math.random() * (temp.length - i));
        data.push(temp[c]);
        temp[c] = temp[temp.length - i - 1];
      }
      return data;
    },
    nowNavInfo() {
      if (this.hoverNav) {
        const info = this.hoverNav.getBoundingClientRect();
        info.queue = this.hoverNav.dataset.queue;
        return info;
      }
      return null;
    },
  },
  watch: {
    $route: {
      handler(val) {
        const typeid = val.params.type;
        const typeName = val.params.name;
        this.listTypeNavs = [
          {
            name: '图片',
            link: `/products/img/${typeName === undefined ? 'sales center' : typeName}/${
              typeid === undefined ? 1 : typeid
            }`,
            sign: 'project-list-type-img',
          },
          {
            name: '列表',
            link: `/products/row/${typeName === undefined ? 'sales center' : typeName}/${
              typeid === undefined ? 1 : typeid
            }`,
            sign: 'project-list-type-row',
          },
        ];
      },
      immediate: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    products().then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    products().then((res) => {
      this.setData(res);
      // next();
    });
    next();
  },
  filters: {
    fillzero(val) {
      return val < 10 ? `0${val}` : val;
    },
  },
  methods: {
    onMouseEnter(el) {
      const c = el.currentTarget;
      const lastQueue = Number(this.nowNavInfo.queue);
      const currentQueue = Number(c.dataset.queue);
      c.classList.remove('pos-r', 'pos-l');
      if (currentQueue !== lastQueue) {
        this.handlMoveLine(c, currentQueue, this.hoverNav, lastQueue);
      }
      this.hoverNav = c;
    },
    onMouseLeave(el) {
      const that = this;
      const c = el.currentTarget;
      const currentQueue = Number(c.dataset.queue);
      if (currentQueue !== this.activeNav) {
        const tempNav = document.querySelectorAll('.nav__item')[that.activeNav];
        c.classList.remove('pos-r', 'pos-l', 'actived');
        this.handlMoveLine(tempNav, that.activeNav, c, currentQueue);
        this.hoverNav = tempNav;
      }
    },
    handlMoveLine(c, currentQueue, l, lastQueue) {
      l.classList.remove('pos-r', 'pos-l', 'actived');
      if (currentQueue > lastQueue) {
        c.classList.add('pos-l', 'actived');
        l.classList.add('pos-r');
      } else if (currentQueue < lastQueue) {
        c.classList.add('pos-r', 'actived');
        l.classList.add('pos-l');
      }
    },
    setData(data) {
      const { $el } = this.$refs.pageFooter;
      $el.style.cssText = 'margin-top:0px';

      const typeId = this.$route.params.type ? this.$route.params.type : 0;
      const types = data.map((item) => ({
        id: item.id,
        name: item.name,
        counts: item.projects.length,
      }));
      const currentType = data.find((item, index) => {
        if (Number(typeId) === 0) {
          return index === 0;
        }
        return Number(item.id) === Number(typeId);
      });
      const activeNav = typeId ? data.findIndex((item) => Number(item.id) === Number(typeId)) : 0;
      const { projects } = currentType;
      this.navs = types;
      this.projects = projects;
      this.activeNav = activeNav;

      this.$nextTick(() => {
        const tempNav = document.querySelectorAll('.nav__item');
        this.hoverNav = tempNav[this.activeNav];
        this.hoverNav.classList.add('actived', 'nowActived');
        setTimeout(() => {
          this.pageInit();
        }, 100);
      });
    },
    pageInit() {
      const { $el } = this.$refs.pageFooter;
      const bcr = $el.getBoundingClientRect();
      if (bcr.bottom < this.$screenHeight) {
        $el.style.cssText = `margin-top:${this.$screenHeight - bcr.bottom}px`;
        this.$emit('notFullScreen');
      }
    },
    onBackTop() {
      this.$emit('afterBackTop');
    },
  },
};
</script>

<style></style>
